// extracted by mini-css-extract-plugin
module.exports = {"slider":"SliderContainer_slider__1uETd","sliderImg":"SliderContainer_sliderImg__2GtB1"};